import { createSlice } from "@reduxjs/toolkit";
import {
  axiosInstance,
  plainAxios,
} from "../../../../Common/Interceptors/AxiosConfig";
import { showNotification } from "../../../../Common/Toast/Toast";

const initialState = {
  errors: null,
  isLoading: false,
  isSuccess: false,
  isAuthenticated: false,
  accessToken: null,
  userData: null,
  refreshToken:null,
};

const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setRefreshToken:(state, action) =>{
      state.refreshToken =action.payload;
    }
  },
});

export const refreshTokenAsync = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const state = getState();
    const refreshToken = state.login.refreshToken || sessionStorage.getItem("refreshToken");

    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const response = await plainAxios.post('/auth/refreshToken', {
      refreshToken: refreshToken
    });

    const { token: newAccessToken, refreshToken: newRefreshToken } = response.data;

    // Store tokens in sessionStorage
    sessionStorage.setItem("token", newAccessToken);
    if (newRefreshToken) {
      sessionStorage.setItem("refreshToken", newRefreshToken);
    }

    dispatch(setAccessToken(newAccessToken));
    dispatch(setRefreshToken(newRefreshToken || refreshToken));
    dispatch(setIsAuthenticated(true));
    dispatch(setLoading(false));
  } catch (error) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("userData");

    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));
    dispatch(setIsAuthenticated(false));
    dispatch(setUserData(null));
    dispatch(setErrors(error?.response));
    dispatch(setLoading(false));

    showNotification({
      message: "Session expired. Please login again.",
      type: "error",
      theme: "light",
    });
  }
};

export const login_OTP_request = (email) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setSuccess(false));

  try {
    let URL = "/auth/login/request";
    const body = { email };
    const response = await plainAxios.post(URL, body);

    if (response.data) {
      dispatch(setSuccess(true));
      dispatch(setLoading(false));
      showNotification({
        message: response?.data?.message,
        theme: "light",
        type: "success",
      });
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setErrors(error?.response));
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong. Please try again.";
    showNotification({
      message: errMsg,
      theme: "light",
      type: "error",
    });
  }
};

export const login_OTP_verify = (email, otp) => async (dispatch) => {
  try {
    let URL = "/auth/login/verify";
    const body = { email, otp };
    const response = await plainAxios.post(URL, body);
    if (response.data) {
      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("userData", JSON.stringify(response.data.user));
      sessionStorage.setItem("refreshToken",response.data.refreshToken);

      localStorage.setItem("token",response.data.token);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      localStorage.setItem("userData", JSON.stringify(response.data.user));
      console.log(response.data,"resposnse");

      dispatch(setUserData(response.data.user));
      dispatch(setAccessToken(response?.data?.token));
      dispatch(setRefreshToken(response?.data?.refreshToken));

      dispatch(setLoading(false));
      dispatch(setSuccess(true));
      dispatch(setIsAuthenticated(true));
      showNotification({
        message: "Login Successfully",
        theme: "light",
        type: "success",
      });
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setErrors(error?.response));
    const errMsg = error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
    showNotification({
      message: errMsg,
      theme: "light",
      type: "error",
    });
  }
};




export const register_OTP_request = (email) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setSuccess(false));

  try {
    let URL = "/auth/register/mail/request";
    const body = { email };
    const response = await plainAxios.post(URL,body);

    if (response.data) {
               dispatch(setLoading(false));
              //  dispatch(setSuccess(true));

         showNotification({
            message: response?.data?.message,
            theme: "light",
            type: "success",
         });
    } 
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setErrors(error?.response));
    const errMsg = error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
    showNotification({
      message: errMsg,
      theme: "light",
      type: "error",
    });
  }
};


export const register_OTP_verify = (email, otp) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setSuccess(false));

  try {
    const URL = "/auth/register/mail/verify";
    const body = { email, otp };
    const response = await plainAxios.post(URL, body);
     if(response.data){
      dispatch(setLoading(false));
      if (response.data.status && response.data.status === "success") {
      dispatch(setSuccess(true));
      showNotification({
        message: response.data?.message,
        theme: "light",
        type: "success",
      });
    }

    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setErrors(error?.response));
    const errMsg = error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
    showNotification({
      message: errMsg,
      theme: "light",
      type: "error",
    });
  }
};



export const register = (email, firstName, lastName, phone,navigate) => async (dispatch) => {
   dispatch(setLoading(true));
   dispatch(setSuccess(false));

    try {
      let URL = "/auth/register";
      const body = { email, firstName, lastName, phone };
      const response = await plainAxios.post(URL,body);

      if (response.data) {
          sessionStorage.setItem("token", response.data.token);
          sessionStorage.setItem("userData", JSON.stringify(response.data.user));
          sessionStorage.setItem("refreshToken",response.data.refreshToken)

         localStorage.setItem("token",response.data.token);
         localStorage.setItem("refreshToken", response.data.refreshToken);
         localStorage.setItem("userData", JSON.stringify(response.data.user));
         console.log(response.data,"resposnse");


          dispatch(setUserData(response.data.user));
          dispatch(setAccessToken(response?.data?.token));
          dispatch(setRefreshToken(response?.data?.refreshToken));

          dispatch(setLoading(false));
          dispatch(setIsAuthenticated(true));
          dispatch(setAccessToken(response.data.token));
          dispatch(setSuccess(true));

          showNotification({
             message: "Regitration Successfull",
             theme: "light",
             type: "success",
          });
          navigate("/");
      } else {
         showNotification({
             message: response?.data?.message || "Something went wrong.",
             theme: "light",
             type: "error",
         });
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setErrors(error?.response));
      const errMsg = error?.response?.data?.message ||  error?.message || "Something went wrong. Please try again.";
      showNotification({
        message: errMsg,
        theme: "light",
        type: "error",
      });
    }
  };


export const logOut = () => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setSuccess(false));

  try {
    await axiosInstance.post("/auth/logout");
  } catch (error) {
    // optional: log or show error
  }

  // Clear both localStorage and sessionStorage
  localStorage.clear();
  sessionStorage.clear();

  // Trigger logout event across tabs
  localStorage.setItem("logout", Date.now().toString());

  // Reset Redux state
  dispatch(setIsAuthenticated(false));
  dispatch(setAccessToken(null));
  dispatch(setUserData(null));
  dispatch(setRefreshToken(null));
  dispatch(setErrors(null));
  dispatch(setSuccess(false));

  showNotification({
    message: "Logout Successful",
    theme: "light",
    type: "success",
  });

  window.location.href = "/login";
};


export const {
  setErrors,
  setLoading,
  setIsAuthenticated,
  setAccessToken,
  setSignup,
  setUserData,
  setSuccess,
  setRefreshToken
} = LoginSlice.actions;

export default LoginSlice.reducer;
